module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-36.76c0ac23.JPG";